import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap'
import { useTranslation } from 'react-i18next'

import { ProfileNav } from 'components/Profile'
import BaseLayout from 'components/BaseLayout'

const Profile = ({ children }) => {
  const { t } = useTranslation()

  return (
    <BaseLayout title={t('profile.title')}>
      <div className="profile-container">
        <Row>
          <Col sm="12" md="3">
            <ProfileNav />
          </Col>
          <Col sm="12" md="8" className="profile__children">
            {children}
          </Col>
        </Row>
      </div>
    </BaseLayout>
  )
}

Profile.propTypes = {
  children: PropTypes.node,
}

export default React.memo(Profile)
